import { render, staticRenderFns } from "./bip-model.vue?vue&type=template&id=393e37bc&"
import script from "./bip-model.vue?vue&type=script&lang=js&"
export * from "./bip-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports